export enum ContestTeamFormation {
    Manual = 'Manual',
    Company = 'Company',
    BusinessUnit = 'BusinessUnit',
    Office = 'Office'
}
